import React, { useState } from 'react';
import MediaQuery from 'react-responsive';
import Clipboard from 'clipboard';
import {
  BodyText,
  HeadingText,
  Dialog,
  Link,
  Sheet,
  IconButton,
  V2ArrowLeftIcon,
} from '@paypalcorp/pp-react';

import SocialShare from './SocialShare';
import CopyButton from './CopyButton/CopyButton';

import HubSocialShare from './HubSocialShare';
import styles from './confirmation.less';
import * as analytics from '../lib/analytics';

const ConfirmationPage = ({
  npid,
  npoUrl,
  campaignInfo,
  fptiInfo,
  pageurl,
  i18n,
  cdnHost,
  subTitle,
  title,
  buttonText,
  copyText,
  inviteText,
  confSocialNeeded,
  socialShareNeeded,
  campaignSocialShare = false,
}) => {
  new Clipboard('#clipBoardTrigger');

  const [isOpen, setIsOpen] = useState(true);
  const [isCopied, setIsCopied] = useState(false);

  const clickCopy = (event) => {
    analytics.trackLink(
      'overlaycopybutton',
      fptiInfo.pgrp,
      fptiInfo.page,
      'link'
    );
  };

  const getDoneButton = () => (
    <div>
      <Link
        tabIndex={0}
        theme='v2'
        onClick={() => setIsOpen(false)}
        onKeyDown={(e) => {
          // ENTER & SPACE BAR
          if (e.keyCode === 13 || e.keyCode === 32) {
            setIsOpen(false);
          }
        }}
      >
        {buttonText}
      </Link>
    </div>
  );

  const renderSocialShare = () => {
    if (socialShareNeeded && confSocialNeeded) {
      return (
        <div style={{ textAlign: 'center' }}>
          <br />
          <div className={styles['copy-button-container']}>
            <CopyButton
              clickCopy={clickCopy}
              copyText={copyText}
              text={pageurl}
            />
          </div>
          <div className={`${styles['social-share-style']}`}>
            <SocialShare
              fptiInfo={fptiInfo}
              campaignInfo={campaignInfo}
              style={{
                marginTop: '14px',
              }}
              socialShareIconsStyle={{
                padding: '12px',
                height: '48px',
                width: '48px',
              }}
            />
          </div>
          {getDoneButton()}
        </div>
      );
    }
  };

  const renderHubSocialShare = () => {
    return (
      <div style={{ textAlign: 'center' }}>
        <BodyText
          as='p'
          size='md'
          regular
          className={styles['social-invite-text']}
          strong
        >
          {inviteText}
        </BodyText>
        <div className={styles['copy-button-container']}>
          <CopyButton clickCopy={clickCopy} copyText={copyText} text={npoUrl} />
        </div>
        <div className={`${styles['social-share-style']}`}>
          <HubSocialShare
            url={npoUrl}
            fptiInfo={fptiInfo}
            i18n={i18n}
            cdnHost={cdnHost}
            style={{
              marginTop: '14px',
            }}
            socialShareIconsStyle={{
              padding: '13px',
            }}
          />
        </div>
        {getDoneButton()}
      </div>
    );
  };

  const renderBody = () => (
    <div className={styles['confirmation-modal-body']}>
      <div className={styles['confirmation-container']}>
        <img
          src={`https://${cdnHost}/paypal-ui/illustrations/focused/svg/cause-success-desktop.svg`}
          alt='confirmpng'
          height='82'
          width='82'
        />
      </div>
      <input type={'hidden'} name={'npid'} id={'nemo_conf_npid'} value={npid} />
      <HeadingText size='lg' className={styles['center-text']}>
        {title}
      </HeadingText>
      <BodyText
        as='p'
        size='md'
        className={`${styles['center-text']} ${styles['extra-margin']}`}
        dangerouslySetInnerHTML={{
          __html: subTitle,
        }}
      ></BodyText>
      {campaignSocialShare ? renderSocialShare() : renderHubSocialShare()}
    </div>
  );

  return (
    <>
      <MediaQuery minWidth={752}>
        <Dialog
          titleId={'campaignConfirmation'}
          id={'campaignConfirmation'}
          className='confirmation-dialog'
          isFullView
          isOpen={isOpen}
          style={{ maxWidth: '42.5rem', height: '728px' }}
        >
          {renderBody()}
        </Dialog>
      </MediaQuery>
      <MediaQuery maxWidth={751}>
        <Sheet
          wrapperClassName={styles['confirmation-sheet-wrapper']}
          containerClassName={styles['confirmation-sheet-container']}
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          mobileFixedHeight='90'
          action={
            <IconButton
              svgIconComponent={V2ArrowLeftIcon}
              buttonType='tertiary'
              theme='v2'
              onClick={(e) => setIsOpen(false)}
            >
              Back
            </IconButton>
          }
          theme='v2'
        >
          {renderBody()}
        </Sheet>
      </MediaQuery>
    </>
  );
};

export default ConfirmationPage;
